var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "icon-details-preview card compact with-border padding-top-0 with-border-radius display-flex flex-column flex-items-stretch flex-content-between",
      staticStyle: { height: "100%", "--card-margin-bottom": "0" },
      style: `${
        _vm.previewMode == "night"
          ? "--border-color: var(--fa-navy); --card-background: var(--fa-navy); --balloon-color: var(--fa-dk-navy); --card-color: var(--white);"
          : "--border-color: var(--fa-lt-gravy);"
      }`,
    },
    [
      _c(
        "div",
        {
          staticClass:
            "padding-y-5xl display-flex flex-column flex-items-center flex-content-center positon-relative z-1",
          staticStyle: {
            "min-height": "var(--icon-details-preview-min-height)",
            "flex-grow": "1",
            "flex-shrink": "0",
            "flex-basis": "auto",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "icon-details-preview-rendering position-absolute display-flex flex-column flex-items-center flex-content-center",
              staticStyle: { inset: "0", overflow: "hidden" },
            },
            [
              !_vm.isCustomIcon
                ? _c("span", [
                    _c("i", {
                      class: [
                        `${_vm.translatedStyle} fa-${_vm.icon.name}${_vm.animation}${_vm.size}${_vm.rotation}`,
                      ],
                      staticStyle: { "line-height": "1" },
                      style: `${
                        _vm.hasCustomRotation ? _vm.customRotation : ""
                      } ${
                        _vm.isDuotone
                          ? _vm.colorPrimary +
                            _vm.colorSecondary +
                            _vm.opacityPrimary +
                            _vm.opacitySecondary
                          : _vm.colorPrimary
                      }`,
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isCustomIcon && _vm.icon
                ? _c(
                    "span",
                    {
                      class: `${_vm.animation}${_vm.size}${_vm.rotation}`,
                      style: `${
                        _vm.hasCustomRotation ? _vm.customRotation : ""
                      } ${
                        _vm.isDuotone
                          ? _vm.colorPrimary +
                            _vm.colorSecondary +
                            _vm.opacityPrimary +
                            _vm.opacitySecondary
                          : _vm.colorPrimary
                      }`,
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "uploaded-icon-preview",
                        staticStyle: { "line-height": "1" },
                        attrs: { icon: _vm.iconDefinition },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.displayIconPreviewControls
        ? _c(
            "div",
            {
              staticClass:
                "icon-details-preview-rendering-controls position-absolute z-2",
              staticStyle: {
                bottom: "var(--spacing-4xl)",
                left: "var(--card-horizontal-padding)",
                right: "var(--card-horizontal-padding)",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "display-flex flex-row flex-nowrap flex-items-center flex-content-between position-absolute",
                  staticStyle: {
                    "--button-margin-bottom": "0",
                    gap: "var(--spacing-xl)",
                    width: "100%",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "flex-grow": "1", "text-align": "left" } },
                    [
                      _c(
                        "button",
                        {
                          class: _vm.styleTabButtonClass,
                          style: _vm.toggleButtonStyle,
                          attrs: {
                            "aria-label": "Show Styling Tools",
                            "data-balloon-pos": "up",
                          },
                          on: { click: _vm.toggleStyleOptions },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v7.solid.faPalette,
                              size: "lg",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasRotation
                        ? _c(
                            "span",
                            {
                              class: _vm.styleTabButtonClass,
                              staticStyle: {
                                color: "var(--fa-gravy)",
                                cursor: "not-allowed",
                                "vertical-align": "middle",
                              },
                              style: _vm.toggleButtonStyle,
                              attrs: {
                                "aria-label":
                                  "Can't animate while rotating or flipping",
                                "data-balloon-pos": "up",
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.$v7.solid.faFilm,
                                  size: "lg",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "button",
                            {
                              class: _vm.styleTabButtonClass,
                              style: _vm.toggleButtonStyle,
                              attrs: {
                                "aria-label": "Show animation options",
                                "data-balloon-pos": "up",
                              },
                              on: { click: _vm.toggleAnimationOptions },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.$v7.solid.faFilm,
                                  size: "lg",
                                },
                              }),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.hasCustomStyling
                        ? _c(
                            "button",
                            {
                              class: _vm.toggleButtonClass,
                              staticStyle: {
                                "margin-left": "var(--spacing-md)",
                              },
                              style: _vm.toggleButtonStyle,
                              attrs: {
                                "aria-label": "Reset Styling",
                                "data-balloon-pos": "up",
                              },
                              on: { click: _vm.resetStyles },
                            },
                            [
                              _vm._v("\n          Reset"),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(" All Custom Styling"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.previewMode == "day"
                    ? _c(
                        "button",
                        {
                          class: _vm.toggleButtonClass,
                          style: _vm.toggleButtonStyle,
                          attrs: {
                            "aria-label": "Nox!",
                            "data-balloon-pos": "up",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.togglePreviewMode("night")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faMoon, size: "lg" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("View Icon on Dark Background"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.previewMode == "night"
                    ? _c(
                        "button",
                        {
                          class: _vm.toggleButtonClass,
                          style: _vm.toggleButtonStyle,
                          attrs: {
                            "aria-label": "Lumos!",
                            "data-balloon-pos": "up",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.togglePreviewMode("day")
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v7.solid.faSunBright,
                              size: "lg",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("View Icon on Light Background"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }